import {
  CurrencyPipe,
  DatePipe,
  TitleCasePipe,
} from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PaginatorModule } from 'primeng/paginator';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';

@Component({
  selector: 'paginated-table',
  standalone: true,
  imports: [
    CurrencyPipe,
    DatePipe,
    TitleCasePipe,
    PaginatorModule,
    TableModule,
    TranslatePipe
  ],
  templateUrl: './paginated-table.component.html',
  styleUrl: './paginated-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatedTableComponent {
  /**
   * The title displayed above the table.
   */
  cardTitle: InputSignal<string> = input.required();
  @Input() noDataMessage: string = "CASE_DETAIL.NO_AVAILABLE_DATA";


  /**
   * The column headers for the table.
   */
  headers: any = input.required();

  /**
   * The data to be displayed in the table rows.
   */
  tableData: any = input.required();

  /**
   * The keys used to extract values from each data row.
   */
  keys: any = input.required();

  /**
   * The data types for each column, used for formatting.
   */
  types: any = input.required();

  /**
   * The number of rows to display per page.
   */
  pageSize: InputSignal<number> = input.required();

  serverPaging = input(false);
  totalRecords = input(0);
  loading = input(false);
  lazyLoad = output<TableLazyLoadEvent>();

  onRowClick: OutputEmitterRef<any> = output();

  rowClick(row: any) {
    this.onRowClick.emit(row)
  }
}
